<p>rxjs サンプル</p>

<div>生成系</div>

<div>
  <button type="button" (click)="from()">Observable.from</button>
  <pre></pre>
</div>

<div>
  <button type="button" (click)="range()">Observable.range</button>
  <pre>
    Rx.Observable.range(start, count, [scheduler])
  </pre>
</div>

<div>
  <button type="button" (click)="defer()">Observable.defer</button>
  <pre></pre>
</div>

<div>
  <button type="button" (click)="interval()">Observable.interval</button>
  <pre></pre>
</div>

<div>
  <h5>一定期間の同じイベントをまとめる</h5>
  <button type="button" (click)="clickEvent('hoge')">hoge</button>
  <button type="button" (click)="clickEvent('fuga')">fuga</button>
  <pre></pre>
</div>

<div>
  <h5>入力されたテキストを(入力途中の値を除く)何とかして取り出す</h5>
  <input (keyup)="onInputEvent($event)" />
</div>
